import ApprovedKyc from "./ApprovedKyc";

export default ApprovedKyc;
